"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiEmployeeLocationFollowsResponse = instanceOfApiEmployeeLocationFollowsResponse;
exports.ApiEmployeeLocationFollowsResponseFromJSON = ApiEmployeeLocationFollowsResponseFromJSON;
exports.ApiEmployeeLocationFollowsResponseFromJSONTyped = ApiEmployeeLocationFollowsResponseFromJSONTyped;
exports.ApiEmployeeLocationFollowsResponseToJSON = ApiEmployeeLocationFollowsResponseToJSON;
exports.ApiEmployeeLocationFollowsResponseToJSONTyped = ApiEmployeeLocationFollowsResponseToJSONTyped;
/**
 * Check if a given object implements the ApiEmployeeLocationFollowsResponse interface.
 */
function instanceOfApiEmployeeLocationFollowsResponse(value) {
    if (!('followedCount' in value) || value['followedCount'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('success' in value) || value['success'] === undefined)
        return false;
    return true;
}
function ApiEmployeeLocationFollowsResponseFromJSON(json) {
    return ApiEmployeeLocationFollowsResponseFromJSONTyped(json, false);
}
function ApiEmployeeLocationFollowsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'followedCount': json['followed_count'],
        'status': json['status'],
        'success': json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
function ApiEmployeeLocationFollowsResponseToJSON(json) {
    return ApiEmployeeLocationFollowsResponseToJSONTyped(json, false);
}
function ApiEmployeeLocationFollowsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'followed_count': value['followedCount'],
        'status': value['status'],
        'success': value['success'],
        'message': value['message'],
    };
}
